import { useState } from "react";

import { useQuery, useMutation } from "@tanstack/react-query";
import {
  Flex,
  Label,
  Button,
  Checkbox,
  FormGroup,
  TextInput,
  InnerPanel,
} from "@sopranodesign/pulse-components";

import { useAuth } from "../../hooks";
import { inviteUser } from "../../api";

const defaultInvite = {
  email: "",
  role: "",
};

const InviteDetails = ({ handleClose }) => {
  const [user, setUser] = useState(defaultInvite);

  const query = useQuery({ queryKey: ["roles"] });

  const { user: authUser } = useAuth();

  const mutation = useMutation({
    mutationFn: inviteUser,
    onSuccess: () => handleClose(),
  });

  const handleSelectRole = (role) => {
    if (user.role === role.id) {
      return setUser({ ...user, role: "" });
    }

    setUser({ ...user, role: role.id });
  };

  const handleEmailChange = (e) => setUser({ ...user, email: e.target.value });

  const handleSubmit = () => {
    mutation.mutate({
      id: authUser.id,
      email: user.email,
      role_id: user.role,
    });
  };

  const valid = Boolean(user.email && user.role);

  return (
    <InnerPanel>
      <FormGroup>
        <Label htmlFor="email">Email</Label>
        <TextInput
          id="email"
          placeholder="name@email.com"
          onChange={handleEmailChange}
          value={user.email}
        />
      </FormGroup>
      <FormGroup>
        <Label>Role</Label>
        {query.isSuccess &&
          query.data.data.map((role) => (
            <Flex mt key={role.id}>
              <Checkbox
                aria-label={`role-select-${role.id}`}
                checked={user.role === role.id}
                label={role.name}
                onChange={() => handleSelectRole(role)}
              />
            </Flex>
          ))}
      </FormGroup>
      <Flex right>
        <Button
          aria-label="submit button"
          disabled={!valid}
          onClick={() => handleSubmit()}
          variant="primary"
        >
          Send invite
        </Button>
      </Flex>
    </InnerPanel>
  );
};

export default InviteDetails;
